import { GENDER } from '../../../pages/Campaigns/constants/ageTargetings';
import type { LineItemForm } from '../../../pages/Campaigns/Form/types';
import { getAgesAndGendersByAgesTargetsValues } from '../../../pages/Campaigns/utils/ageTargetings';

export const TARGETING_CATEGORY = {
  LOCATION: 'location',
  GENDER: 'gender',
  AGE_GROUPS: 'age_groups',
  AUDIENCES: 'audiences',
  DEVICE_TYPES: 'device_types',
  GENRES: 'genres',
} as const;

export type TargetingCategory = (typeof TARGETING_CATEGORY)[keyof typeof TARGETING_CATEGORY];

export const getAppliedTargetingCategories = (values: LineItemForm): TargetingCategory[] => {
  const categories: TargetingCategory[] = [];
  const { ages: ageGroups, genders } = getAgesAndGendersByAgesTargetsValues(values.ages);

  if (values.locationTargetings.length > 0 || (values.zipCodes?.length ?? 0) > 0) {
    categories.push(TARGETING_CATEGORY.LOCATION);
  }

  if (genders.some((gender) => gender !== GENDER.all)) {
    categories.push(TARGETING_CATEGORY.GENDER);
  }

  if (ageGroups.length > 0) {
    categories.push(TARGETING_CATEGORY.AGE_GROUPS);
  }

  if (values.audiences.length > 0) {
    categories.push(TARGETING_CATEGORY.AUDIENCES);
  }

  if (values.platform.length > 0) {
    categories.push(TARGETING_CATEGORY.DEVICE_TYPES);
  }

  if (values.contentTargetings.length > 0) {
    categories.push(TARGETING_CATEGORY.GENRES);
  }

  return categories;
};

export const hasSpecificTargetingApplied = (values: LineItemForm): boolean =>
  getAppliedTargetingCategories(values).length > 0 || values.retargetings.length > 0;
